/**
 * TIP Shell — imperative iframe mount point. The sealed iframe is created and appended
 * OUTSIDE Preact's controlled subtree (the seal attributes live in seal.ts, one audited
 * place) and dropped into the `#frame-mount` container the Preact App renders. Order is
 * decoupled: the frame can be produced before or after the container mounts.
 */
let frameMountEl: HTMLElement | null = null;
const pending: HTMLIFrameElement[] = [];

/** Called by the Preact FrameMount component once its container is in the DOM. */
export function registerFrameMount(el: HTMLElement): void {
  frameMountEl = el;
  while (pending.length) {
    const f = pending.shift();
    if (f) el.appendChild(f);
  }
}

/** Called by the bootstrap once the sealed iframe exists. */
export function mountFrame(iframe: HTMLIFrameElement): void {
  if (frameMountEl) frameMountEl.appendChild(iframe);
  else pending.push(iframe);
}
